export const entities = state => state.entities
